import { CloseOutlined, ShareOutlined } from '@mui/icons-material';
import { Button, Dialog, DialogContent, Typography } from '@mui/material';
import { WidgetIcon, useCustomSnackbar } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { CloseButton, DialogHeader, TextFieldStyled, Title } from './FilterSharePopover.styled';

interface FilterSharePopoverProps {
  url?: string;
  onClose: () => void;
}

export const FilterSharePopover = ({ url, onClose }: FilterSharePopoverProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'FilterSharePopover' });
  const { enqueueSuccessSnackbar } = useCustomSnackbar();

  const handleClick = () => {
    navigator.clipboard.writeText(url ?? '');
    enqueueSuccessSnackbar(t('savedToClipboard'));
  };

  return (
    <Dialog open={!!url} onClose={onClose}>
      <DialogHeader>
        <WidgetIcon icon={<ShareOutlined fontSize="small" />} />
        <Title variant="subtitle1">{t('shareFilter')}</Title>
        <CloseButton onClick={onClose}>
          <CloseOutlined />
        </CloseButton>
      </DialogHeader>
      <DialogContent dividers>
        <TextFieldStyled sx={{ width: 396 }} value={url} variant="outlined" size="small" type="url" />
        <Button
          sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, height: 40 }}
          variant="contained"
          color="primary"
          onClick={handleClick}
        >
          <Typography variant="button">{t('copyLink')}</Typography>
        </Button>
      </DialogContent>
    </Dialog>
  );
};
